export const c_table_m_grid__check_favorite_action_MarginLeft = {
  "name": "--pf-c-table--m-grid__check--favorite--action--MarginLeft",
  "value": "calc(2rem + 3rem)",
  "var": "var(--pf-c-table--m-grid__check--favorite--action--MarginLeft)"
};
export default c_table_m_grid__check_favorite_action_MarginLeft;